import {http} from '../shared/services';
import React from 'react';
import {Route} from 'react-router';
import {CommunityLessonDetailPage, CoreLessonDetailPage, PendingLessonDetailPage} from './components';

// TODO: Handle this with Cancan on the server
const authorizeUser = (nextState, replace, callback) => {
  http.get(`user_owns_pending_lesson/${nextState.params.lessonId}`).then(
    result => {
      if (!result.data) replace('/not-authorized');
      callback();
    },
    () => {
      replace('/');
      callback();
    }
  );
};

export default (
  <Route>
    <Route path="/lesson/:lessonId" component={CoreLessonDetailPage} />
    <Route path="/community/lesson/:lessonId" component={CommunityLessonDetailPage} />
    <Route path="/pending/lesson/:lessonId" component={PendingLessonDetailPage} onEnter={authorizeUser} />
  </Route>
);



// WEBPACK FOOTER //
// ./app/features/lessonDetail/routes.js